import { render, staticRenderFns } from "./deliveryDetails.vue?vue&type=template&id=3c95b1d2"
import script from "./deliveryDetails.vue?vue&type=script&lang=js"
export * from "./deliveryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports